module.exports = __webpack_public_path__ + "img/rock-big-12.2b560586.png";